<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div style="display: flex; justify-content: flex-start;">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="home-center" style="margin-top: -190px;height: calc(100vh + 130px)">
              <iframe ref="myIframe" :src="dashboardUrl" style="width: 100%;height: 100%;border: none;"></iframe>
            </div>
          </el-main>
        </slot>
      </div>
    </div>
    <publicFooter></publicFooter>
  </el-container>
</template>

<script scoped>
import { dashBoard } from '@/request/dashboard.js'
import publicFooter from '@/components/public/publicFooter'
import publicSearch from '@/components/public/publicSearch'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
export default {
  name: 'dashboard',
  components: {
    publicFooter,
    publicHeader,
    publicSearch,
    publicMenu
  },
  props: [],
  data () {
    return {
      dashboardUrl: '',
      isCollapse: this.common.collapseSet(),
      language: this.common.languageSet(this),
      currency: this.common.currencySet(this),
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      source: ''
    }
  },
  created: function () {
  },
  mounted: function () {
    this.dashBoardShow()
  },
  methods: {
    getPermissions (value) {
      this.allPermissions = value
    },
    dashBoardShow () {
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        token = ''
      }
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {
        'language': this.language,
        'source': this.source,
        'token': token,
        'time': time,
        'operation': 'info'
      }
      var data = this.common.encryptionData(dataJson, this)
      dashBoard(data).then(res => {
        console.log(res)
        if (res.flag === '200') {
          this.dashboardUrl = res.data.url
        }
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    }
  }
}
</script>
<style type="text/css" scoped>
  body > .el-container {margin-bottom: 40px;}
  .el-container{display:block;}
  /* 搜索 */
  .search{ height:100px;margin: 10px; background: #FFF; border-radius: 5px;}
  .search-info{ height: 50px; padding: 25px 2% 0px 2%;}
  /* orderno */
  .hotellist-region{width:40%;float: left;margin-right:0.5%;}
  .hotellist-region input, .search-status input{background-color:rgba(255,255,255,1);background-image:url(/static/img/account/icon_u25.png);background-repeat:no-repeat;background-size: 20px;background-position: 12px center;padding: 0px 50px;width: 100%; height: 48px;font-size: 16px;opacity:1;}
  .hotellist-region /deep/ .el-input__inner:focus,.hotellist-region input:focus, .search-status /deep/ .el-input__inner:focus,.search-status input:focus{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 8px rgba(83, 102, 163, 1);}
  .hotellist-region /deep/ .el-input__inner{padding: 0 60px;height: 48px; background-image: url(/static/img/account/icon_u25.png);background-repeat: no-repeat;background-size: 20px;background-position: 15px center;border: 1px solid rgba(83, 102, 163, 1);}
  .hotellist-region /deep/ .el-popover--plain{width:100%;padding:0px;color: #FF6B6D;top: -33px;font-size:12px;height: 28px;line-height: 28px;z-index: 2001;text-align:center;}

  /* 订单状态 */
  .search-status{width:18.5%;float: left;margin-right:0.5%;}
  .search-status .el-select{width: 100% !important;}
  .search-status /deep/ .el-input__inner{height: 48px;border: 1px solid rgba(83, 102, 163, 1);}
  /* 按钮 */
  .input_button,.input_button:hover,.input_button:focus{ height: 48px; width: 10% !important; margin-left: 0.3% !important;}

  /* 列表 */
  .account-list{min-height:200px; margin: 20px 10px 10px; background: #FFF; border-radius: 5px; padding:25px 2%;}
  .accountlist{width: 96%; background-color: rgba(242, 242, 242, 1);height: 40px;border: none; font-weight: 650; font-size: 16px; color: #333333; line-height: 40px; padding: 0 2%;border-radius: 5px;}
  .accountlist div, .hotel-info div{display:inline-block; float: left;}
  .hotel-info{width: 96%; min-height:50px;height: auto; line-height: 50px; border: none; color: #333333;padding: 0 2%;border-bottom: 1px solid #d2cfcf; clear: both; font-size: 14px;}

  /* 分页 */
  .account-data-page{width:98%;height:100px;text-align:right;margin-top: 40px; padding-right: 2%;}
  .account-data-page .el-pagination.is-background .el-pager li,.account-data-page .el-pagination.is-background .btn-prev,.account-data-page .el-pagination.is-background .btn-next{background:white;}
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active, /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{background-color:rgba(83, 102, 163, 1); color:#FFF;}
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover{background-color:#296FF7; cursor: pointer;}

  /* 骨架屏 */
  .template-text{width: 80%;margin: 13.5px 0;}
  .template-info-text{width: 80%;margin: 19px 0;}
  .account-list /deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover, .hotel-info  /deep/ .el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover{box-shadow: none;}

  /* 创建 */
  .dia-content{ margin-top: 20px;border-bottom: 1px solid rgba(83, 102, 163, 1);}
  .dia-content /deep/ .el-input__inner{ width: 300px; border: 1px solid rgba(83, 102, 163, 1);}
  .email-info /deep/ .el-input__inner, .firstname-info /deep/ .el-input__inner, .lastname-info /deep/ .el-input__inner, .permissions-info /deep/ .el-input__inner, .password-info /deep/ .el-input__inner{ width: 300px; border: 1px solid rgba(225, 45, 45, 1);}
  .open-dia /deep/ .el-button+.el-button{margin-left:0px;}
  .open-dia /deep/ .el-button:hover{color:#FFF;background: rgba(41, 111, 247, 1);border: 1px solid rgba(41, 111, 247, 1);}
  .otherreason-msg{border:1px solid red;}
  .open-dia /deep/ .el-dialog__body{padding:0px;color:#333333;}
  .open-dia /deep/ .el-dialog__header{padding: 20px 20px;height: 20px; font-size: 22px; font-weight: 650; line-height: 20px; border-bottom: 1px solid rgba(83, 102, 163, 1);}
  /deep/ .el-select .el-input__inner:focus, .el-select .el-input.is-focus .el-input__inner,.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner, /deep/ .el-input.is-active .el-input__inner, /deep/ .el-input__inner:focus{border-color:rgba(83, 102, 163, 1) !important;box-shadow:0px 0px 8px rgba(83, 102, 163, 1);}
  /deep/ .el-select-dropdown__item.selected{color: rgba(83, 102, 163, 1) !important;}
  /deep/ .el-dialog__footer{padding: 20px;}
  /deep/ .el-dialog__headerbtn .el-dialog__close{color: rgba(83, 102, 163, 1);font-weight: 650;}
  .codeError,.codeError:focus,.codeError:hover{background: inherit;background-color: rgba(255, 255, 255, 1);box-sizing: border-box;border: 2px solid rgba(225, 45, 45, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue